var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.546 17.9542C19.7574 18.1656 19.8761 18.4522 19.8761 18.7511C19.8761 19.05 19.7574 19.3366 19.546 19.548C19.3347 19.7593 19.048 19.8781 18.7491 19.8781C18.4503 19.8781 18.1636 19.7593 17.9523 19.548L12.0001 13.5939L6.04602 19.5461C5.83467 19.7574 5.54803 19.8762 5.24914 19.8762C4.95026 19.8762 4.66361 19.7574 4.45227 19.5461C4.24092 19.3348 4.12219 19.0481 4.12219 18.7492C4.12219 18.4503 4.24092 18.1637 4.45227 17.9524L10.4063 12.0002L4.45414 6.0461C4.2428 5.83476 4.12407 5.54811 4.12407 5.24923C4.12407 4.95034 4.2428 4.6637 4.45414 4.45235C4.66549 4.24101 4.95213 4.12228 5.25102 4.12228C5.5499 4.12228 5.83655 4.24101 6.04789 4.45235L12.0001 10.4064L17.9541 4.45141C18.1655 4.24007 18.4521 4.12134 18.751 4.12134C19.0499 4.12134 19.3365 4.24007 19.5479 4.45141C19.7592 4.66276 19.878 4.9494 19.878 5.24829C19.878 5.54718 19.7592 5.83382 19.5479 6.04516L13.5938 12.0002L19.546 17.9542Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.c56a7a703726e9ea4ee1e2e8a7bc1d8c.svg";
export { ForwardRef as ReactComponent };